import { render, staticRenderFns } from "./i-sidebar.vue?vue&type=template&id=290218af&scoped=true&"
import script from "./i-sidebar.vue?vue&type=script&lang=js&"
export * from "./i-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./i-sidebar.vue?vue&type=style&index=0&id=290218af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290218af",
  null
  
)

export default component.exports